define('quiz_view',[
    'bootstrap',
    'results_view_factory',
    'service__number_translate',
    'service__share_text',
    'bump-3',
    'utils'
], function (news, ResultsViewFactory, Numbers, ShareText, bump, utils) {

    var View = function (elm, vocab, allFeedback, quizInAnIframe, iframeWrapper) {
        this.elm = news.$(elm);
        this.vocab = vocab;
        this.allFeedback = allFeedback;
        this.quizInAnIframe = quizInAnIframe;
        this.iframeWrapper = iframeWrapper;
        this.resultsView = ResultsViewFactory.setupResultsView(this.elm, this.vocab, this.allFeedback);
        this.setupHtml();
        this.setupPubsubs();
        this.setupEvents();
        this.decideHowToDisplayProgress();
        this.updateProgress(0, 0);
        this.displayWide();
        this.quizContentNamespace =  'quiz-content-' + Math.floor((Math.random() * 500000) + 1);
        news.$('.quiz').attr('id', this.quizContentNamespace);
        news.pubsub.emit('quiz:requestFirstQuestion');
    };

    View.prototype = {
        elm: null,
        setupHtml: function () {
            this.elm.append(
                '<div class="question">' +
                    '<div class="question__img" tabindex="0"></div>' +
                    '<div class="question__video" id="mediaPlayer"></div>' +
                    '<div class="question__text"></div>' +
                    '<ul class="question__list-of-options"></ul>' +
                    '<div class="question__supporting-text-generic"></div>' +
                    '<div class="question__supporting-text"></div>' +
                    '<div class="question__feedback-image"></div>' +
                '</div>');
            this.elm.append(
                '<div class="progress-bar">' +
                    '<div class="progress-bar__indicator"><div>' +
                '</div>');
            this.elm.append(
                '<div class="quiz-footer">' +
                    '<div class="quiz-footer__item quiz-footer__item--running-score"></div>' +
                    '<div class="quiz-footer__item quiz-footer__item--progress-index"></div>' +
                    '<div class="quiz-footer__item quiz-footer__item--next-holder">' +
                        '<button class="quiz-btn quiz-btn--next">' + this.vocab.next + '</button>' +
                    '</div>' +
                '</div>');


            this.resultsView.setupHtml();

            this.elm.append(
                '<div class="more-quiz-section">' +
                    '<div class="more-quiz-section__text"></div>' +
                    '<div class="more-quiz-section__title"></div>' +
                    '<div class="more-quiz-section__links"></div>' +
                '</div>'
            );
        },
        setupPubsubs: function () { // would prefer this to call methods on class directly, but pubsub lib binds callbacks to jquery for chaining
            var View = this;
            news.pubsub.on('quiz:showQuestion', function (question, options, optionsKeys, supportingText, feedback, feedbackImages, questionImg, questionVideo, videoVersionExists) {
                View.renderQuestion(question, options, optionsKeys, supportingText, feedback, feedbackImages, questionImg, questionVideo, videoVersionExists);
            });
            news.pubsub.on('quiz:end', function (score, outOf, feedback) {
                View.elm.removeClass('quiz-content--mode-question quiz-content--answer-chosen');
                View.elm.addClass('quiz-content--mode-result');
                if (View.vocab.useTransitions) {
                    View.doResultDisplayTransition();
                }
                View.resultsView.render(score, outOf, feedback);
                if (View.vocab.moreQuizLinks.length > 0) {
                    View.renderMoreQuizSection();
                }
                if (View.vocab.useSocialMedia) {
                    news.pubsub.emit('shareTools:message', [ShareText.get(View.vocab, score, outOf)]);
                }
            });
            news.pubsub.on('quiz:progress', function (currentQuestion, totalNumberOfQuestions) {
                View.updateProgress(currentQuestion, totalNumberOfQuestions);
            });
            news.pubsub.on('quiz:renderRunningScore', function (runningScore, totalNumberOfQuestions) {
                View.renderRunningScore(runningScore, totalNumberOfQuestions);
            });
            news.pubsub.on('quiz:runningScore', function (answer) {
                View.setAnswerChosenTo(true);
            });
        },
        setupEvents: function () {
            var View = this;
            news.$('.question__list-of-options').on('click', function (e) {
                var targetElm = e.target || e.srcElement;
                if (targetElm.nodeName === 'INPUT' || targetElm.nodeName === 'LABEL') {
                    if (View.answerHasNotBeenChosen()){
                        View.tickTheRadioButton(targetElm);
                    }
                }
            });

            news.$('.question__list-of-options').on('keydown', function (e) {
                View.submitAnswerIfUserPressedSpaceOrEnter(e);
            });

            View.applyQuestionsStylesOnFocusAndBlur();

            news.$('.quiz-btn--next').on('click', function () {
                View.nextButtonClick();
            });
            news.$('.quiz-btn--restart').on('click', function () {
                View.resetButtonClick();
            });
        },
        setAnswerChosenTo: function (answerWasChosen) {
            if (answerWasChosen) {
                this.elm.addClass('quiz-content--answer-chosen');
            } else {
                this.elm.removeClass('quiz-content--answer-chosen');
            }
        },
        answerHasNotBeenChosen: function () {
            return !this.elm.hasClass('quiz-content--answer-chosen');
        },
        applyQuestionsStylesOnFocusAndBlur: function (e) {
            var View = this;
            news.$('.question__list-of-options').on('focusin', function (e) {
                if (View.answerHasNotBeenChosen()) {
                    var targetElm = e.target || e.srcElement;
                    news.$(targetElm).addClass('question__option--selected');
                }
            }).on('focusout', function (e) {
                if (View.answerHasNotBeenChosen()) {
                    var targetElm = e.target || e.srcElement;
                    news.$(targetElm).removeClass('question__option--selected');
                }
            });
        },
        submitAnswerIfUserPressedSpaceOrEnter: function (e) {
            var targetElm = e.target || e.srcElement;
            if (e.which === 13 || e.which === 32) {
                this.tickTheRadioButton(targetElm);
            } else { // remove highlighted style from blurred (de-selected) answers.
                news.$(targetElm).removeClass('question__option--selected');
            }
        },
        tickTheRadioButton: function (targetElm) {
            if (this.answerHasNotBeenChosen()) {
                news.$(targetElm).find('.question__checkbox:enabled').prop('checked', true);
                var feedback = news.$(targetElm).find('.question__checkbox').data('feedback') || news.$(targetElm).data('feedback');
                var feedbackImage = news.$(targetElm).find('.question__checkbox').data('feedback-image') || news.$(targetElm).data('feedback-image');
                this.showSupportingText(feedback);
                this.showFeedbackImage(feedbackImage);
                this.showNextButton();
                if (!this.vocab.quizAllowAnswerChange) {
                    this.disableOtherOptions();
                }
                var eventToEmit = this.vocab.quizAllowAnswerChange ? 'quiz:runningScoreWhenAnswerCanBeChanged' : 'quiz:runningScore',
                    scoreToAdd = this.elm.find('.question__checkbox:checked').val();
                news.pubsub.emit(eventToEmit, [scoreToAdd]);

            }
        },
        questionHasVideo: function (questionVideo) {
            if(typeof questionVideo === undefined) {
                return false;
            } else if (questionVideo === '') {
                return false;
            }
            if ( document.getElementById('vj-bbc-app') !== null) {
                return false;
            }
            return true;
        },
        renderQuestion: function (question, options, optionsKeys, supportingText, feedback, feedbackImages, questionImg, questionVideo, videoVersionExists) {
            this.elm.addClass('quiz-content--mode-question');

            this.setAnswerChosenTo(false);

            if (this.vocab.useTransitions) {
                this.doQuestionTransition();
            }

            this.resultsView.goAway();

            this.renderQuestionImage(questionImg);

            if (this.questionHasVideo(questionVideo)) {
                this.renderQuestionVideo(questionVideo, questionImg, question, videoVersionExists);
            } else {
                this.elm.find('.question__video').hide();
            }

            this.elm.find('.question__text').html(question);
            this.elm.find('.question__list-of-options').html('');

            var View = this,
                optionFeedbackIndex = 0;
            news.$.each(optionsKeys, function (key, value) {
                var valueToUse = String(value);
                var optionId = 'question__checkbox--' + (valueToUse.split(' ').join(''));
                var optionFeedback = feedback[optionFeedbackIndex];
                var optionFeedbackImage = feedbackImages[optionFeedbackIndex];
                var $li = news.$('<li class="question__option" tabindex="0">' +
                                    '<label class="question__option-label">' +
                                        '<input type="radio" name="quiz--option" id="' + optionId + '" value="' + valueToUse +
                                            '" class="question__checkbox" tabindex="-40000" />' +
                                        '<span class="question__option-text">' + value + '</span>' +
                                    '</label>' +
                                '</li>');

                $questionCheckbox = $li.find('.question__checkbox');

                $questionCheckbox.data('feedback', optionFeedback);
                $questionCheckbox.data('feedback-image', optionFeedbackImage);

                View.elm.find('.question__list-of-options').append($li);
                optionFeedbackIndex++;
            });

            this.elm.find('.question__img').focus();
            this.elm.find('.question__supporting-text-generic').html(supportingText);
            this.elm.find('.question__supporting-text').hide();
            this.elm.find('.question__feedback-image').hide();
            this.elm.find('.quiz-btn--next').hide();
        },
        showSupportingText: function (specificFeedback) {
            if (specificFeedback === undefined) {
                return;
            }
            var supportingText = '<p>' + specificFeedback + '</p><p>' + this.elm.find('.question__supporting-text-generic').html() + '</p>';

            if (this.vocab.useTransitions) {
                this.doShowSupportingTextTransition(supportingText);
            } else {
                this.elm.find('.question__supporting-text').show().html(supportingText);
            }
        },
        showFeedbackImage: function (feedbackImage) {
            if (feedbackImage) {
                this.elm.find('.question__feedback-image')
                    .show()
                    .html('<img src="' + feedbackImage + '" alt="">');
            }
        },
        showNextButton: function () {
            this.elm.find('.quiz-btn--next').show();
        },
        disableOtherOptions: function () {
            var radioButton;
            news.$('.question__checkbox').each(function () {
                radioButton = news.$(this);
                if (!radioButton.is(':checked')) {
                    //radioButton.parent().parent().prop('tabIndex', -40000);
                    radioButton.attr('disabled', 'disabled');
                    radioButton.parent().parent().addClass('question__option--disabled');
                } else {
                    radioButton.parent().parent().addClass('question__option--selected');
                }
            });
        },
        resetButtonClick: function () {
            news.pubsub.emit('quiz:reset');
            news.pubsub.emit('shareTools:reset');
            this.showElemsHiddenOnResultDisplay();
        },
        nextButtonClick: function () {
            var elemToScrollTo = this.elm.find('.question__img');
            this.scrollToElem(elemToScrollTo);
            news.pubsub.emit('quiz:getNextQuestion');
        },
        decideHowToDisplayProgress: function () {
            if (this.vocab.useProgressBar) {
                news.$('.quiz-footer__item--progress-index').remove();
            } else {
                news.$('.progress-bar').remove();
            }
        },
        updateProgress: function (currentQuestion, totalNumberOfQuestions) {
            if (this.vocab.useProgressBar) {
                this.updateProgressBar(currentQuestion, totalNumberOfQuestions);
            } else {
                this.updateProgressIndex(currentQuestion, totalNumberOfQuestions);
            }
        },
        updateProgressBar: function (currentQuestion, totalNumberOfQuestions) {
            var progress = Math.floor((currentQuestion / (totalNumberOfQuestions + 1)) * 100);
            if (isNaN(progress)) {
                progress = 0;
            }
            this.elm.find('.progress-bar__indicator').css('width', progress + '%');
            this.elm.find('.question')[0].className = ('question question--' + currentQuestion);
        },
        updateProgressIndex: function (currentQuestion, totalNumberOfQuestions) {
            var progressIndex = Numbers.translate(this.vocab, currentQuestion, totalNumberOfQuestions);

            // hacky manual override for News
            if (this.vocab.service === 'news') {
                progressIndex = 'Question&#58; ' + progressIndex;
            }

            this.elm.find('.quiz-footer__item--progress-index').html('<p>' + progressIndex + '</p>');
        },
        renderQuestionImage: function (questionImg) {
            if (questionImg.src) {
                // @TODO - make the alt text language agnostic
                this.elm.find('.question__img').html('<img src="' + questionImg.src + '" alt="Question Image">');
                this.elm.find('.question__img').show();
            } else {
                this.elm.find('.question__img').html('');
            }
        },
        renderQuestionVideo: function (questionVideo, questionImg, question, videoVersionExists){
            var videoEnv,
                mediaPlayerSettings,
                mediaPlayer;

            if (this.vocab.makeVideoFallbackToImages || !videoVersionExists) {
                this.elm.find('.question__video').hide();
            } else if (!utils.cutsTheMustard()){
                this.elm.find('.question__video').show();
                this.elm.find('.question__video').html('<p class="question__video-warning">Quiz videos are optimised for modern browsers - to see the video player on this page, please upgrade your version of Internet Explorer or use a different browser.</p>');
            } else {
                this.elm.find('.question__img').hide();
                this.elm.find('.question__video').show();

                videoEnv = this.getVideoEnvironment();
                mediaPlayerSettings = {
                    product :           videoEnv.product,
                    mediaProfile:       videoEnv.mediaProfile,
                    playerProfile:      'smp',
                    insideIframe:       !!this.quizInAnIframe,
                    responsive:         true,
                    overrideHoldingImage: questionImg.src,
                    statsObject:        { clipPID: questionVideo },
                    imgTag:             questionImg,
                    playlistObject: {
                        title: news.$(question).text(),
                        holdingImageURL: questionImg.src,
                        items : [ { vpid : questionVideo } ]
                    },
                    ui: {
                        locale: { lang: videoEnv.langCode }
                    }
                };
                mediaPlayer = bump('#mediaPlayer').player(mediaPlayerSettings);
                this.smpHackToWorkInIframes(mediaPlayer);
                mediaPlayer.load();
            }
            return mediaPlayerSettings;
        },
        smpHackToWorkInIframes: function (mediaPlayer) {
            if (typeof mediaPlayer.bind === 'function') {
                if (this.quizInAnIframe) {
                    mediaPlayer.bind('navigateTo', function(e) {
                        top.location = e.href;
                    });
                }
            }
        },
        getVideoEnvironment: function () {
            var mediaProfile = 'journalism',
                product      = 'news',
                langCode     = 'en-gb';

            langCode = utils.getLangCodeFromServiceName(this.vocab.service);

            return {
                product:        product,
                mediaProfile:   mediaProfile,
                langCode:       langCode
            };
        },
        renderRunningScore: function (runningScore, totalNumberOfQuestions) {
            var scoreText = this.vocab.score + ' ' + Numbers.translate(this.vocab, runningScore, totalNumberOfQuestions);
            this.elm.find('.quiz-footer__item--running-score').html('<p>' + scoreText + '</p>');
        },
        renderMoreQuizSection : function () {
            if (this.vocab.moreQuizLinks.length > 0) {

                var moreQuizLinkHtml = '';

                moreQuizLinkHtml += '<ul>';
                news.$.each(this.vocab.moreQuizLinks, function (key, value) {
                    moreQuizLinkHtml += '<li><a href="' + value.link + '" target="_parent">' + value.title + '</a></li>';
                });
                moreQuizLinkHtml += '</ul>';

                this.elm.find('.more-quiz-section__text').html(this.vocab.moreQuizText);
                this.elm.find('.more-quiz-section__title').html(this.vocab.more_quizzes);
                this.elm.find('.more-quiz-section__links').html(moreQuizLinkHtml);
            }
        },
        checkThenSetViewport : function (position) {
            var el = document.getElementById(this.quizContentNamespace),
                elDim = el.getBoundingClientRect(),
                w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            var elementToScrollTo = this.elm.find('.question__img'),
                needsToScrollUp   = (position === 'bottom' && elDim.bottom < h),
                needsToScrollDown = (position === 'top' && elDim.top < 0);

            if (needsToScrollUp || needsToScrollDown) {
                // temporarily commented out until a better solution is foun
                if (this.quizInAnIframe){
                   this.scrollToTop(news.$('quiz'));
                } else {
                    this.scrollToElem(elementToScrollTo);
                }
            }
        },
        scrollToTop: function(elemToScrollTo) {
            news.$('html, body').animate({
                scrollTop: news.$(elemToScrollTo).top
            }, 500);
        },
        scrollToElem: function(elemToScrollTo) {
            news.$('html, body').animate({
                scrollTop: news.$(elemToScrollTo).offset().top
            }, 500);
        },
        showElemsHiddenOnResultDisplay: function () {
            news.$('.quiz__header').show();
            news.$('.quiz__img').show();
            news.$('.quiz__intro-text').show();
        },
        doQuestionTransition: function () {
            news.$('.quiz-content--mode-question').css('opacity', '0');
            news.$('.quiz-content--mode-question').fadeTo('slow', 1);
        },
        doResultDisplayTransition: function () {
            news.$('.quiz-content--mode-result').css('opacity', '0');
            news.$('.quiz-content--mode-result').fadeTo('slow', 1);
        },
        doShowSupportingTextTransition: function (supportingText) {
            var View = this;
            this.elm.find('.question__supporting-text').html(supportingText);
            View.checkThenSetViewport('bottom');
            news.$('.question__supporting-text').css('opacity', '0');
            news.$('.question__supporting-text').delay(100).fadeTo(650, 1);
        },
        displayWide: function () {
            var View = this;
            if (View.vocab.displayWide) {
                news.$('.quiz').css('max-width', 'none');
                news.$('.quiz').css('background-color', '#efefef');
                return true;
            }
            return false;
        }
    };

    return View;
});

